import { Axios } from "api/axios";

export const WEB_SYNC_JOB_STORAGE_KEY = "abgb_web_sync_job_id";

export type WebSyncJobSummary = {
  job_id: string;
  job_type: string;
  status: string;
  total_count: number;
  processed_count: number;
  success_count: number;
  failed_count: number;
  pending_count: number;
  progress_percent: number;
  started_at?: string | null;
  finished_at?: string | null;
  last_error?: string;
};

const TERMINAL_STATUSES = new Set([
  "completed",
  "completed_with_errors",
  "failed",
]);

export function isWebSyncJobTerminal(status: string): boolean {
  return TERMINAL_STATUSES.has(status);
}

export async function fetchActiveWebSyncJob(): Promise<WebSyncJobSummary | null> {
  const res = await Axios.get("api/item/web-sync/jobs/active/");
  return res.data?.job ?? null;
}

export async function fetchWebSyncJob(
  jobId: string,
  includeLines = false
): Promise<WebSyncJobSummary | null> {
  const res = await Axios.get(
    `api/item/web-sync/jobs/${jobId}/`,
    { params: includeLines ? { include_lines: "1" } : {} }
  );
  return res.data?.job ?? null;
}

export type StartWebSyncJobBody = {
  password: string;
  item_sku?: string;
  item_skus?: string[];
};

export async function startWebSyncJob(body: StartWebSyncJobBody) {
  return Axios.post("api/item/web-sync/jobs/", body);
}

export function persistWebSyncJobId(jobId: string | null) {
  if (jobId) {
    localStorage.setItem(WEB_SYNC_JOB_STORAGE_KEY, jobId);
  } else {
    localStorage.removeItem(WEB_SYNC_JOB_STORAGE_KEY);
  }
}

export function readStoredWebSyncJobId(): string | null {
  return localStorage.getItem(WEB_SYNC_JOB_STORAGE_KEY);
}
